<template>
  <div>
    <span
      type="submit"
      class="btn btn-success btn-wd"
      @click.prevent="apply_action()"
    >
      {{ action_data.label }}
    </span>
  </div>
</template>

<script>
import ActionModal from '../../Actions/ActionModal.vue'
import ActionEvents from '../../Actions/ActionEvents.vue'

export default {
  name: "ActionButton",
  props: {
    profile: {
      type: Object,
      default: null,
    },
    service_name: {
      type: String,
      default: 'http'
    },
    action_data: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      error: false,
    };
  },

  methods: {
    apply_action () {
      var t = this.$createElement(ActionModal, {
        props: {
          hidden_data: this.action_data.hidden_data,
          label: this.action_data.label
        },
        on: {
          close: () => { this.$modal.hide('dynamic-modal') },
          apply: (val) => {
            if(this.service_name === 'http')
              this.run_http_action(val)
            else
              this.run_rabbitmq_action(val)
          }
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})
    },
    run_http_action(data) {
      this.$http.simcard.runSimcardActions(this.profile.id, this.action_data.action, this.action_data.protocol ,data, (response) => {
        if (response.data.status) {
          if (response.data.length > 0) {
            var t = this.$createElement(ActionEvents, {
              props: { events: response.data },
              on: {
                close: () => { this.$modal.hide('dynamic-modal') },
              }
            })
            let temp = {
              render () { return t }
            }
            this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})
          }else{
            this.global_notify('success', this.translate('task.comlete_new_task'))
            this.$emit('reload')
          }
        }else{
          this.global_notify('danger', this.translate('task.error_new_task'))
        }
      });
    },
    run_rabbitmq_action(data) {
      this.$http.simcard.runNewSimcardActions(this.profile.id, { action:this.action_data.action, service_name: this.service_name, task_data: data}, (response) => {
        if (response.data.status) {
          if (response.data.length > 0) {
            var t = this.$createElement(ActionEvents, {
              props: { events: response.data },
              on: {
                close: () => { this.$modal.hide('dynamic-modal') },
              }
            })
            let temp = {
              render () { return t }
            }
            this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})
          }else{
            this.global_notify('success', this.translate('task.comlete_new_task'))
            this.$emit('reload')
          }
        }else{
          this.global_notify('danger', this.translate('task.error_new_task'))
        }
      });
      // console.log('send to rabbitmq')
    },
  },
};
</script>
<style lang="scss">
.link_simcard {
  cursor: pointer;
  transition: 0.2s;
  &:hover {
    background-color: #eee;
  }
}
</style>
